import { State } from 'oidc-client-ts';

export async function getLogoutRedirectState() {
  const stateQuery = new URLSearchParams(window.location.search).get('state');
  if (stateQuery) {
    const storageKey = `oidc.${stateQuery}`;
    const storageStr = localStorage.getItem(storageKey);
    if (storageStr) {
      localStorage.removeItem(storageKey);
      try {
        const data = await State.fromStorageString(storageStr);
        return data;
      } catch {
        return null;
      }
    }
  }
  return null;
}
